// ** Reducers Imports
// import navbar from "./navbar";
import layout from "./layout";
import auth from "./authentication";
import navigationStep from "./navigationStep";

const rootReducer = {
  auth,
  // navbar,
  layout,
  navigationStep,
};

export default rootReducer;
